import React, { useEffect, useState } from "react";
import PropertyCard from "../components/PropertyCard";
import { properties } from "../data/properties";
import "../Styles/PropertyList.css";

const PropertyListings = () => {
  const [visibleCount, setVisibleCount] = useState(20); // initially show 20 properties
  const [visibleProperties, setVisibleProperties] = useState([]);

  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top when page loads
    setVisibleProperties(properties.slice(0, visibleCount));
  }, [visibleCount]);

  const handleViewMore = () => {
    setVisibleCount((prev) => Math.min(prev + 20, properties.length));
  };

  return (
    <div className="property-listings-container">
      <div className="listings-title-wrapper">
        <h2 className="listings-title">Properties</h2>
      </div>

      <div className="listings-grid">
        {visibleProperties.map((prop, idx) => (
          <PropertyCard key={idx} property={prop} />
        ))}
      </div>

      {visibleCount < properties.length && (
        <div className="view-more-wrapper">
          <button className="view-more-btn" onClick={handleViewMore}>
            View More
          </button>
        </div>
      )}
    </div>
  );
};

export default PropertyListings;
